/* eslint-disable-next-line import/no-unresolved */
import { useCallback, useMemo } from 'react';
/* eslint-disable-next-line import/no-unresolved */
import { useDispatch, useSelector } from 'react-redux';
import { TAB_INDIVIDUAL_NOTICE } from '../constants/message';
import { markAsReadRequest } from '../redux/actions/messageActions';
import { ALL_SERVICES, SERVICE_ID_TO_VALUE } from '../constants/core';
import { getSlashedDateStringWithoutTime } from '../services';

const PREFIX_ACTION_TYPE = 'action:';
const isActionType = (action) => action != null && action.startsWith(PREFIX_ACTION_TYPE);
const getActionType = (action) => action.slice(PREFIX_ACTION_TYPE.length);

export const useMessage = ({ message, browse, channel }) => {
  const dispatch = useDispatch();
  const currentTab = useSelector((state) => state.message.currentTab);
  const { action, linkUrl, messageId, status, startTime, endTime, targetServices } = message || {};
  const serviceValues = useMemo(
    () => targetServices?.map(({ serviceId: serviceValue }) => serviceValue) ?? [],
    [targetServices],
  );
  const showMessage = useCallback(() => {
    if (isActionType(action)) {
      const type = getActionType(action);
      const { parameters = null } = status || {};
      dispatch({ type, payload: { linkUrl, messageId, parameters, serviceValues } });
    } else {
      browse({ linkUrl, messageId });
      const isIndividual = currentTab === TAB_INDIVIDUAL_NOTICE;
      dispatch(markAsReadRequest({ messageId, isIndividual, channel }));
    }
  }, [dispatch, browse, channel, action, linkUrl, messageId, status, serviceValues, currentTab]);
  const endDateDisplay = useMemo(() => {
    const eTime = status?.endTime ?? endTime;
    if (!eTime) {
      return null;
    }
    return `${getSlashedDateStringWithoutTime(eTime)}まで`;
  }, [status, endTime]);
  const startDateDisplay = useMemo(
    () => getSlashedDateStringWithoutTime(status?.startTime ?? startTime),
    [startTime, status],
  );

  return useMemo(() => {
    return {
      endDateDisplay,
      startDateDisplay,
      showMessage,
    };
  }, [endDateDisplay, startDateDisplay, showMessage]);
};

export const useRangeOutList = ({ parameters, serviceValues }) => {
  return useMemo(() => {
    const serviceValueSet = new Set(serviceValues);
    const rangeOutMap = JSON.parse(parameters ?? null) || {};
    return ALL_SERVICES.map((serviceId) => SERVICE_ID_TO_VALUE[serviceId])
      .filter((serviceValue) => serviceValueSet.has(serviceValue))
      .flatMap((serviceValue) => rangeOutMap[serviceValue] ?? []);
  }, [parameters, serviceValues]);
};
